/**
 * "Comprimă proiecte": three projects' lines running into a single arrow.
 *
 * Drawn here because lucide has nothing like it, on the same 24-unit grid and in
 * `currentColor`, so it sits among the lucide icons of a row's actions and takes
 * its size from the same `h-4 w-4`.
 */
export function MergeProjectsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 16V6" />
      <path d="M4 16v-2.5l8-3 8 3V16" />
      <path d="M12 1.5 15 6.5H9z" fill="currentColor" stroke="none" />
      <circle cx="4" cy="19" r="2.75" fill="currentColor" stroke="none" />
      <circle cx="12" cy="19" r="2.75" fill="currentColor" stroke="none" />
      <circle cx="20" cy="19" r="2.75" fill="currentColor" stroke="none" />
    </svg>
  );
}
